export default function EyeIcon({color,size}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      style={{ transform: `scale(${size || 1})` }}
    >
      <g clip-path="url(#clip0_774_1070)">
        <path
          d="M9.50001 14.5661C4.64751 14.5661 0.826257 10.1373 0.665007 9.94984C0.443757 9.69109 0.443757 9.31234 0.665007 9.05359C0.826257 8.86234 4.64751 4.43359 9.50001 4.43359C14.3525 4.43359 18.1738 8.86234 18.335 9.04984C18.5563 9.30859 18.5563 9.68734 18.335 9.94609C18.1738 10.1373 14.3525 14.5661 9.50001 14.5661ZM2.14251 9.49984C3.20376 10.5686 6.14001 13.1823 9.50001 13.1823C12.86 13.1823 15.7963 10.5723 16.8575 9.49984C15.7963 8.43109 12.86 5.81734 9.50001 5.81734C6.14001 5.81734 3.20376 8.43109 2.14251 9.49984Z"
          fill={color ||"#36363D"}
        />
        <path
          d="M9.5 12.5189C7.835 12.5189 6.48125 11.1652 6.48125 9.5002C6.48125 7.8352 7.835 6.48145 9.5 6.48145C11.165 6.48145 12.5187 7.8352 12.5187 9.5002C12.5187 11.1652 11.165 12.5189 9.5 12.5189ZM9.5 7.8652C8.6 7.8652 7.865 8.59645 7.865 9.5002C7.865 10.4002 8.59625 11.1352 9.5 11.1352C10.4 11.1352 11.135 10.4039 11.135 9.5002C11.135 8.6002 10.4 7.8652 9.5 7.8652Z"
          fill={color||"#36363D"}
        />
      </g>
      <defs>
        <clipPath id="clip0_774_1070">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
